import $http from '../api/http'

const dashboard = {
  // 获取短信送达率统计信息
  async getMessageStats (params) {
    return $http('/api/messages/stats', {
      method: 'GET',
      params: { ...params }
    });
  }
};

export default dashboard;



// WEBPACK FOOTER //
// ./src/api/dashboard.js